import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useMediaQuery,
  useTheme,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LogoutIcon from '@mui/icons-material/Logout'; // Import Logout icon
import logo from '../assets/femizero-logo.png';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate(); // Initialize useNavigate

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Automatically close the drawer when the screen size changes to larger devices
  useEffect(() => {
    if (!isMobile) {
      setMobileOpen(false);
    }
  }, [isMobile]);

  // Handle logout
  const handleLogout = () => {
    // Perform logout actions (e.g., clear authentication state)
    localStorage.removeItem('isAuthenticated'); // Example: Clear authentication state
    navigate('/login'); // Redirect to the login page
  };

  const drawer = (
    <div>
      {/* Close Button */}
      <IconButton
        onClick={handleDrawerToggle}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'inherit' }}
      >
        <CloseIcon />
      </IconButton>

      {/* Navigation Items with Icons */}
      <List sx={{ mt: 10 }}> {/* Increased margin-top */}
        <ListItem button key="Incident Reports" component={Link} to="/portal" onClick={handleDrawerToggle}>
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Incident Reports" />
        </ListItem>
        <ListItem button key="Logout" onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      {/* Fixed Header */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: '#ff69b4', // Pinkish gradient background
        }}
      >
        <Toolbar>
          <Typography component="div" sx={{ flexGrow: 1 }}>
            {/* Clickable Logo */}
            <Link to="/" style={{ textDecoration: 'none', flexGrow: 1 }}>
              <img
                src={logo}
                alt="FemiZero Logo"
                style={{ height: '80px', marginRight: '10px' }}
              />
            </Link>
          </Typography>
          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <>
              <Button color="inherit" component={Link} to="/portal" startIcon={<AssignmentIcon />}>
                Incident Reports
              </Button>
              <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
                Logout
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
      <Drawer anchor="left" open={mobileOpen} onClose={handleDrawerToggle}>
        {drawer}
      </Drawer>

      {/* Main Content with Padding to Avoid Overlapping */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, marginTop: '64px' }}>
        {/* Your main content goes here */}
      </Box>
    </>
  );
};

export default Navbar;